import { Component, Input, OnChanges, OnInit, TemplateRef, ViewChild, ViewContainerRef } from '@angular/core';
import { Observable } from 'rxjs';

// client (demo services)
// import { HttpClient } from "../services/client"
import { DemoService } from '../../../demo.service';


// interface (models)
// import { IUser } from "../services/interfaces"

import { FilterService, GridComponent, PageService, PdfExportService, SearchSettingsModel, SortService, ToolbarService } from '@syncfusion/ej2-angular-grids';
import { DataStateChangeEventArgs } from '@syncfusion/ej2-angular-grids';

import { enableRipple } from '@syncfusion/ej2-base';
// enable ripple effects
enableRipple(true);
import { DataManager  } from '@syncfusion/ej2-data';
import { FilterSettingsModel } from '@syncfusion/ej2-grids';

import {  IFilter } from '@syncfusion/ej2-angular-grids';
import {  ToolbarItems, GroupSettingsModel,
RowDataBoundEventArgs } from '@syncfusion/ej2-angular-grids';
import { ClickEventArgs } from '@syncfusion/ej2-angular-navigations';

import { IFilterUI } from '@syncfusion/ej2-angular-grids';
import { DatePicker } from '@syncfusion/ej2-calendars';
import { ActivatedRoute, Router } from '@angular/router';
import { DatePipe } from '@angular/common';
import { GlobalFunctionsService } from './../../../services/global-functions.service';
// import { HotToastService } from '@ngneat/hot-toast';


import {SubjectNotes} from './../../../shared/models/subjectNotes.model';
import { inputs } from '@syncfusion/ej2-angular-dropdowns/src/drop-down-list/dropdownlist.component';
import { SubjectNote } from './../../../api/subjectNote';
import { BsModalRef, BsModalService } from 'ngx-bootstrap';
import { DomSanitizer } from '@angular/platform-browser';

import { Clipboard } from '@angular/cdk/clipboard'; // using the clipboard
import { HotToastService } from '@ngneat/hot-toast';

export const COPY = 'Copy';
export const COPIED = 'Copied';

@Component({
  selector: 'app-jobs-subjects-notes-grid',
  templateUrl: './jobs-subjects-notes-grid.component.html',
  styleUrls: ['./jobs-subjects-notes-grid.component.css']
})
export class JobsSubjectsNotesGridComponent implements OnInit, OnChanges {

 // passed Values.
   // setup as observable?
   @Input() item_id; // impliments on changes. // Base set to Job_ID
   @Input() item_data?; // if data.model is sent ;
   @Input() use_item_data? = false; // if data.model is sent use this instead of item_id
   
   @Input() item_user_level_id = null; // default to agent just in case
   @Input() item_brand_type_id = null;
   @Input() item_brand_id = null;
   @Input() item_subject_id? = null;
   @Input() item_subject_number? = null;
   
   @Input() show_buttons? = false; // yes | no
   @Input() item_title? = '';
   @Input() widget_size? = null; // side | abstract | full

   @Input() job_id? = null;
   @Input() file_number = null; // subject file number
   @Input() reference_number = null; // subject file number


  // @ViewChild('grid')
  // public grid: GridComponent;
  @ViewChild('grid') public grid: GridComponent;
  // public grid: GridComponent;
  public searchOptions: SearchSettingsModel;
 


 
  public pageSettings: Object;
  public pageOptions = { pageSize: 30 }; 
  public filterOptions: FilterSettingsModel;
  public formatOptions: any;
  // public filterOptions: FilterSettingsModel;
  public filter: IFilter;
  public toolbarOptions: ToolbarItems[] | object;
  public groupOptions: GroupSettingsModel;
  public templateOptionsDate: IFilterUI;
  public elem1: HTMLElement;
  public datePickerObj: DatePicker;
  initialPage: { pageSize: number; };
  dateFormat: string;
 
  
  subject_id: null; // set to empty to prevent errors if not set
  model: {}; // put model for variables for sql where statements.
  subjectNote: SubjectNotes;
  notes: any;
  note: SubjectNotes;
  notes_data: Object;
  sessionUserId: any;
  sessionUsername: any;
  sessionBrandId: any;
  all_router_details: string;
  show_agents: any;
  agent_array: any;
 
  modalRef: BsModalRef;


    btnOneTxt = COPY;
    btnTwoTxt = COPY;
  users: Object;
  usersList: any;
  userRow: Object;

  
  constructor(
    private _demoService: DemoService,
    private route: ActivatedRoute, private router: Router,
    public datepipe: DatePipe,  public gfunc: GlobalFunctionsService,
    vcr: ViewContainerRef, private modalService: BsModalService,
    private sanitizer: DomSanitizer,
    private clipboard: Clipboard, // ciipboard
    public toastr: HotToastService
    ) {




    // Set and Access login Session Variables
            // this.gfunc.setLoginSessionVars(); // set in a global function file
            // this.sessionUserId = this.gfunc.currentUserVAR.user_id;
            // this.sessionUsername = this.gfunc.currentUserVAR.username;
            // this.sessionBrandId = this.gfunc.currentUserVAR.brand_id;

// need to add this as routes does not work globally
this.all_router_details = this.router.url;
this.gfunc.current_base_route = this.router.url.substr(0, this.all_router_details.lastIndexOf('/'));
        // Setup Grid
/*         this.toolbarOptions = [ 'Search', {
          text: '-',
          tooltipText: 'Submit Data to Send Agent Notifications', prefixIcon: 'e-test', id: 'Clic2k'
        }
        ]; */
        this.toolbarOptions = ['Search'];
        // this.toolbar = [
        // { text: 'Agent Update Request', tooltipText: 'Click', prefixIcon: 'e-expand', id: 'Click' }];
      //  this.initialPage = { pageSize: 100 };
        this.filterOptions = {
          type: 'Menu'
        };
        this.groupOptions = { columns: ['subject_number'] }; // sets auto grouping for the grid
        this.formatOptions = { type: 'date', format: 'dd/MM/yyyy' };
        this.dateFormat = 'dd/MM/yyyy hh:mm a';
        this.filter = { params: { format: this.dateFormat } };


   }


   // check for changes. to load data.
   ngOnChanges(changes) {





    if (changes.item_id) {
      // deal with asynchronous Observable result
     this.subject_id = changes.item_id.currentValue;
    //  this.getJob(this.job_id);
     // this.getFiles();
   
    //console.log('so it does instigate here on changes');

     // put model.
this.model = {
  subject_id: this.item_id,
  brand_type_id: this.item_brand_type_id, // show files only related to login brand. client | owner | agent
  subject_number: this.item_subject_number,
  file_number: this.file_number,
  reference_number: this.reference_number,
  job_id: this.job_id,
  brand_id: this.item_brand_id,
};
   // this.getSubjectNotesGrid(this.model); // Put Event instead of Get?? Do I get a response of data?// use for all jobs
    
 if (this.widget_size == 'side'){
   this.getSubjectNotesProgressionTableLimit5(this.job_id, this.file_number, this.model);
   this.note = new SubjectNotes();
 }else{

      // get teh user llist to fileter if not agent created
             
          // this.getUsers()
       this.getSubjectNotesProgressionTable(this.job_id, this.file_number, this.model);
              
          
          
      //     setTimeout(() => {  
      //           console.log("A Simple Pause! OnChanges 4"); 
      //  this.getSubjectNotesProgressionTable(this.job_id, this.file_number, this.model);
      //               console.log("Now Ready to load...");
      //           }, 10000);
                

              

  // this.getSubjectNotesProgressionTable(this.job_id, this.file_number, this.model);
 }
 
 
  }

    
   // if (changes.item_data) {
      // deal with asynchronous Observable result
     // this.job_id = changes.item_id.currentValue;
     // this.getJob(this.job_id);
    // this.getSubjectNotes(this.subject_id);

 //   }
  }


   ngOnInit() {
   // this.getFiles();
   // Moved to observables.
   
  }


  getSubjectNotesGrid(model) {
    this._demoService.getSubjectNotesGrid(model).subscribe(
      data => { this.notes = data;















       // console.log("Done loadng USER");
       // console.log(this.users);
      },
      error => {
      //  console.error('Error Loading User!');
      // return Observable.throw(error);
      }
    ); }



    getSubjectNotesProgressionTable(job_id, file_number, model) {



      this.notes = [];
      this.show_agents = [];
      this._demoService.getSubjectNotesProgressionTable(job_id, file_number, model).subscribe(
        data => { this.notes_data = data;
         // this.notes = data;
          // console.log("Done loadng USER");
         // console.log(this.users);
         if (this.gfunc.sessionUserLevel == 5) {
// array for agents display test may not be correct if other agents?
         let newArrA = data;
        //  let  count_of_items = Object.keys(newArrA).length;
        let  count_of_items = Object.keys(newArrA).length;
           // need to do a loop of subject_billing items (.length)
           for(let i=0;i < count_of_items; i++) {
           let res = newArrA[i];

           // just grabs the first agent.
           this.agent_array = JSON.parse(res.assigned_to_agents);

          //  this.show_agents.push({
          //    recipient_name: res.recipient_name + '',
          //    recipient_email_address: res.recipient_email_address,
          //    recipient_brand_id: res.recipient_brand_id,
          //    recipient_subject_id: res.subject_id,
          //    recipient_brand_type_id: res.brand_type_id,
          //    recipient_user_id: null,
          //    recipient_user_level_id: null,
          //    recipient_type_name: 'Agent',
          //  });
           } // end for loop
        //  this.show_agents = this.show_agents; // ?? this may be causing errors.
 this.show_agents = this.agent_array; // ?? this may be causing errors.
          }

         // new sysetm to filter only notes for agents views.
if (this.gfunc.sessionUserLevel == 5) {
  console.log('Agent Login Detected: ', this.gfunc.sessionBrandName);
  // need to filter the results if exists in the assinged_to_agents array, create a new note array
  let array = [];
  let newArr = Object(data).filter((sbi)=>(sbi.assigned_to_agents !== '[]')); // User this if filter is needed.
 
  // let newArr = data;
  let  count_of_items = Object.keys(newArr).length;
    // need to do a loop of subject_billing items (.length)
    for(let i=0;i < count_of_items; i++) {
      let res = newArr[i];
      // ned to see if exists in array if so push to notes array.
  
      
      // array = res.assigned_to_agents;
  array = JSON.parse(res.assigned_to_agents);
  console.log('array: ', array);
  
      let ata_array = array.filter( (n: any) => (
          n.recipient_brand_id === this.gfunc.sessionBrandId
          // n.note_id >= '200'
          // && sbi.subject_id === this.subject_service_metrix_search_full_results[i].subject_id
          ));
  
  // console.log('ata_array: ', JSON.stringify(ata_array));
  // console.log('ata_array.lenght: ', ata_array.length);
  
  // console.log('assigned_to_agents: ', JSON.stringify(res.assigned_to_agents));
  
  // only add if exsists in array
  if (ata_array.length === 1) {
    this.notes.push({
    ...newArr[i]
    });
  } // end if array.lenght
  
  } // end for loop
  
  console.log('Filtered Agent Notes: ', JSON.stringify(this.notes));
    this.grid.refresh();
  // this.allRecipients = this.allRecipients; // ?? this may be causing errors.
  
  
  
  
  
  
  
  // filters the notes and checks if the current agent brand id exists in the array
  // tslint:disable-next-line:max-line-length
            // this.notes = this.notes_data.filter( (n: any) => (
            //   n.assigned_to_agents[0].recipient_brand_id === this.gfunc.sessionBrandId
            
            //   // n.note_id >= '200'
            //   // && sbi.subject_id === this.subject_service_metrix_search_full_results[i].subject_id
            //   ));
  
            // console.log('Filtered Agent Notes: ', JSON.stringify(this.notes));
  console.log('Current Brand ID: ', this.gfunc.sessionBrandId);
  
        // let newArr = Object(data).filter((sbi)=>(
        //   sbi.assigned_to_agents != '[]'
        //   && sbi.assigned_to_agents.recipient_brand_id === this.gfunc.sessionBrandId
        //   )); // User this if filter is needed.
        // // let newArr = data;
  
        // let  count_of_items = Object.keys(newArr).length;
        //   // need to do a loop of subject_billing items (.length)
        //   for(let i=0;i < count_of_items; i++) {
        //   let res = newArr[i];
        //   this.notes.push({
        // ...newArr[i],
        //   });
        //   } // end for loop
        // // this.notes = this.notes; // ?? this may be causing errors.
        //   console.log('Filtered Agent Notes: ', JSON.stringify(this.notes));
        // this.grid.refresh();
  
  
  
        // :: Filter object inside an object - using findIndex.
        // @https://stackoverflow.com/questions/43405841/filtering-json-object-on-an-object-inside-an-object
        // group3Items = items.filter(item => item.groups.includes(group => group.id==3))
  
        // tslint:disable-next-line:max-line-length
        // let group3Items =  this.notes_data.filter(item => item.assigned_to_agents[0].findIndex(group => group.recipient_brand_id==this.gfunc.sessionBrandId) > -1);
  
        //       let group3Items = this.notes_data.filter(
        //         item => item.assigned_to_agents !== '[]'
        //         && item.assigned_to_agents.includes(assigned_to_agents => assigned_to_agents.recipient_brand_id === '99')
        //         );
        // this.notes = group3Items;
        //       console.log('Filtered Agent Notes: ', JSON.stringify(this.notes));
        // this.grid.refresh();
  
  
  
        // new function that does the magic
        // this.transform(JSON.stringify(this.notes), this.gfunc.sessionBrandId);
  }else {
     this.notes = data;
  } // end if agent logged in.

   

  // if (this.gfunc.sessionUserLevel == 9) {
  //   this.notes = []; // empty the array first
  //   let newArr = Object(data).filter((sbi)=>(
  //     sbi.brand_id === this.gfunc.sessionBrandId &&
  // sbi.brand_type_id === 'Client'
  //     )); // User this if filter is needed.
  //   // WORKED https://www.syncfusion.com/forums/152967/no-filter-result-using-date-column-in-ejs-grid-angular
  // //  this.notes = DataUtil.parse.parseJson(newArr);
  //  this.notes = newArr;
  // // this.notes = data; // activated so clients can see notes
  // // this.notes_table = newArr.slice(0, 10);
       
  //   } // end if agent logged in.


  // Set for all agent generated content.
  //   // THIS WORED for addtional "sessionBrand_is_client_show_agent_level" permissinos for notes on the subject card for client
      //     if (this.gfunc.sessionUserLevel == 9 && this.gfunc.sessionBrand_is_client_show_agent_level == '1') {
      //   this.notes = []; // empty the array first
      //   let newArr = Object(data).filter((sbi)=>(
      //     sbi.brand_id === this.gfunc.sessionBrandId &&
      // sbi.brand_type_id === 'Client' || sbi.brand_type_id === 'Agent'

      //     )); // User this if filter is needed.
      //   // WORKED https://www.syncfusion.com/forums/152967/no-filter-result-using-date-column-in-ejs-grid-angular
      // //  this.notes = DataUtil.parse.parseJson(newArr);
      //  this.notes = newArr;
      // // this.notes = data; // activated so clients can see notes
      // // this.notes_table = newArr.slice(0, 10);
          
      //   } // end if agent logged in.


//new way show all and remove by agent created level. -- THIS WORKS BUT NEED TO UPDATE ALL API TO RETURN THIS>...
// sbi.brand_id === this.gfunc.sessionBrandId && s
if (this.gfunc.sessionUserLevel == 9 && this.gfunc.sessionBrand_is_client_show_agent_level == '1'  ) {
  this.notes = Object(data).filter((sbi) => {
    // const user = this.usersList.find(u => u.id === sbi.created_by_id);
    return (
      sbi.created_by_level !== "5" && sbi.brand_type_id !== 'TSA Staff' 
    );
  });
}



      // if (this.gfunc.sessionUserLevel == 9 && this.gfunc.sessionBrand_is_client_show_agent_level == '1') {
      //   this.notes = []; // clear first
        
      //   // First filter on brand criteria
      //   let preFiltered = Object(data).filter((sbi) => (
      //     sbi.brand_id === this.gfunc.sessionBrandId &&
      //     // sbi.created_by_id !== 108
      //     sbi.brand_type_id == 'Client' || sbi.brand_type_id == 'Agent'
      //   ));

      //   // Now filter out those with user_level == 5
      //   Promise.all(preFiltered.map(async (note) => {
      //     // const user = await this._demoService.getUserById_promise(note.created_by_id);
      //     const user = await this._demoService.getUserById_promise(108);
      //     return user.access_level !== 5 ? note : null;
      //     // return user.user_id !== 108 ? note : null;

      //     // return user;
      //   }))
        
      //   .then(filteredResults => {
      //     // Remove nulls
      //     // this.notes = filteredResults.filter(n => n !== null);
      //     this.notes = filteredResults;
      //   });
        
      // }




  
        },
        error => {
        //  console.error('Error Loading User!');
        // return Observable.throw(error);
        }
      ); }


      getSubjectNotesProgressionTableLimit5(job_id, file_number, model) {
        this.notes = [];
        this.show_agents = [];
        this._demoService.getSubjectNotesProgressionTableLimit5(job_id, file_number, model).subscribe(
          data => { this.notes_data = data;
           // this.notes = data;
            // console.log("Done loadng Limited Notes");
           // console.log(this.users);

// array for agents display test may not be correct if other agents?
let newArrA = data;
//  let  count_of_items = Object.keys(newArrA).length;
let  count_of_items = Object.keys(newArrA).length;
   // need to do a loop of subject_billing items (.length)
   for(let i=0;i < count_of_items; i++) {
   let res = newArrA[i];

   // just grabs the first agent.
   this.agent_array = JSON.parse(res.assigned_to_agents);

  //  this.show_agents.push({
  //    recipient_name: res.recipient_name + '',
  //    recipient_email_address: res.recipient_email_address,
  //    recipient_brand_id: res.recipient_brand_id,
  //    recipient_subject_id: res.subject_id,
  //    recipient_brand_type_id: res.brand_type_id,
  //    recipient_user_id: null,
  //    recipient_user_level_id: null,
  //    recipient_type_name: 'Agent',
  //  });
   } // end for loop
//  this.show_agents = this.show_agents; // ?? this may be causing errors.
this.show_agents = this.agent_array; // ?? this may be causing errors.

           // new sysetm to filter only notes for agents views.
if (this.gfunc.sessionUserLevel == 5) {
  console.log('Agent Login Detected: ', this.gfunc.sessionBrandName);
  // need to filter the results if exists in the assinged_to_agents array, create a new note array
  let array = [];
  let newArr = Object(data).filter((sbi)=>(sbi.assigned_to_agents !== '[]')); // User this if filter is needed.
  // let newArr = data;
  let  count_of_items = Object.keys(newArr).length;
    // need to do a loop of subject_billing items (.length)
    for(let i=0;i < count_of_items; i++) {
      let res = newArr[i];
      // ned to see if exists in array if so push to notes array.
  
      
      // array = res.assigned_to_agents;
  array = JSON.parse(res.assigned_to_agents);
  // console.log('array: ', array);
  
      let ata_array = array.filter( (n: any) => (
          n.recipient_brand_id === this.gfunc.sessionBrandId
          // n.note_id >= '200'
          // && sbi.subject_id === this.subject_service_metrix_search_full_results[i].subject_id
          ));
  
  // console.log('ata_array: ', JSON.stringify(ata_array));
  // console.log('ata_array.lenght: ', ata_array.length);
  
  // console.log('assigned_to_agents: ', JSON.stringify(res.assigned_to_agents));
  
  // only add if exsists in array
  if (ata_array.length === 1) {
    this.notes.push({
    ...newArr[i]
    });
  } // end if array.lenght
  
  } // end for loop
  
  // console.log('Filtered Agent Notes: ', JSON.stringify(this.notes));
    // this.grid.refresh();
  // this.allRecipients = this.allRecipients; // ?? this may be causing errors.
  
  
  
  
  
  
  
  // filters the notes and checks if the current agent brand id exists in the array
  // tslint:disable-next-line:max-line-length
            // this.notes = this.notes_data.filter( (n: any) => (
            //   n.assigned_to_agents[0].recipient_brand_id === this.gfunc.sessionBrandId
            
            //   // n.note_id >= '200'
            //   // && sbi.subject_id === this.subject_service_metrix_search_full_results[i].subject_id
            //   ));
  
            // console.log('Filtered Agent Notes: ', JSON.stringify(this.notes));
  // console.log('Current Brand ID: ', this.gfunc.sessionBrandId);
  
        // let newArr = Object(data).filter((sbi)=>(
        //   sbi.assigned_to_agents != '[]'
        //   && sbi.assigned_to_agents.recipient_brand_id === this.gfunc.sessionBrandId
        //   )); // User this if filter is needed.
        // // let newArr = data;
  
        // let  count_of_items = Object.keys(newArr).length;
        //   // need to do a loop of subject_billing items (.length)
        //   for(let i=0;i < count_of_items; i++) {
        //   let res = newArr[i];
        //   this.notes.push({
        // ...newArr[i],
        //   });
        //   } // end for loop
        // // this.notes = this.notes; // ?? this may be causing errors.
        //   console.log('Filtered Agent Notes: ', JSON.stringify(this.notes));
        // this.grid.refresh();
  
  
  
        // :: Filter object inside an object - using findIndex.
        // @https://stackoverflow.com/questions/43405841/filtering-json-object-on-an-object-inside-an-object
        // group3Items = items.filter(item => item.groups.includes(group => group.id==3))
  
        // tslint:disable-next-line:max-line-length
        // let group3Items =  this.notes_data.filter(item => item.assigned_to_agents[0].findIndex(group => group.recipient_brand_id==this.gfunc.sessionBrandId) > -1);
  
        //       let group3Items = this.notes_data.filter(
        //         item => item.assigned_to_agents !== '[]'
        //         && item.assigned_to_agents.includes(assigned_to_agents => assigned_to_agents.recipient_brand_id === '99')
        //         );
        // this.notes = group3Items;
        //       console.log('Filtered Agent Notes: ', JSON.stringify(this.notes));
        // this.grid.refresh();
  
  
  
        // new function that does the magic
        // this.transform(JSON.stringify(this.notes), this.gfunc.sessionBrandId);
  }else {
     this.notes = data;
  } // end if agent logged in.

   
  if (this.gfunc.sessionUserLevel == 9) {
    this.notes = []; // empty the array first
    let newArr = Object(data).filter((sbi)=>(
      sbi.brand_id === this.gfunc.sessionBrandId 
      && sbi.brand_type_id === 'Client' // what is this for??? APril 30 2023
      )); // User this if filter is needed.
    // WORKED https://www.syncfusion.com/forums/152967/no-filter-result-using-date-column-in-ejs-grid-angular
  //  this.notes = DataUtil.parse.parseJson(newArr);
   this.notes = newArr;
  // this.notes = data; // activated so clients can see notes
  // this.notes_table = newArr.slice(0, 10);
       
    } // end if agent logged in.


    
          },
          error => {
           console.error(error);
          // return Observable.throw(error);
          }
        ); }




        deleteSubjectNote(note_id, assigned_from_note_id) {
this.gfunc.deleteSystemNote(note_id, assigned_from_note_id);
this.refreshGrid();
          //   if (confirm('Are you sure you want to delete this note? ')) {
        //     this._demoService.deleteSubjectNote(note_id).subscribe(
        //        data => {
        //         this.refreshGrid();
        //        },
        //        error => {
        //          console.error('Error deleting Trace Candidate Note!');
        //         return console.log(error);
        //        }
        //     );
        // }
        }



// nSome grid functions

toolbarClick(args: ClickEventArgs): void {
  if (args.item.id === 'Grid_excelexport') { // 'Grid_excelexport' -> Grid component id + _ + toolbar item name
      this.grid.excelExport();
  }
}
rowDataBound(args: RowDataBoundEventArgs) {
  const job_status = 'job_status';
  if (args.data[job_status] === 'CLOSED') {
      args.row.className = 'strikethrough';
  }
}


clickHandler(args: ClickEventArgs): void {
  if (args.item.id === 'Click') {

  //  this.grid.showSpinner();

  //    alert('This function will trigger the action to Emails, and Status Notifications to Agents');
 //  console.log(args.data.items);
 


  let pdfdata;
  const query = this.grid.renderModule.data.generateQuery(); // get grid corresponding query
  for (let i = 0; i < query.queries.length; i++) {
    if (query.queries[i].fn === 'onPage') {
      query.queries.splice(i, 1);       // remove page query to get all records
      break;
    }
  }
  const fdata = new DataManager({ json: this.notes }).executeQuery(query).then((e: any) => {
    pdfdata = e.result as object[];  // get all filtered records
    const exportProperties = {
      dataSource: pdfdata,
    };
    // console.log(pdfdata.results);
    
   // this.search_results = pdfdata.records; // need this if a grouping is set.
/*     this.search_results = pdfdata;
    this.toastr.info( this.search_results.length + ' subjects added to the update Request Que'); 
    this.toastr.success( "Press Start To Process Que");  */
   // this.grid.pdfExport(exportProperties);
  }).catch((e) => true);
  }

 //  this.grid.hideSpinner();

}

 clientSubjectEditLink(subject_id) {
  this.router.navigate(['/admin/jobs/subject/edit/' + subject_id + '']);
}


clientViewSystemFile(file_id) {
  this.router.navigate(['/admin/system-file-manager/system-file/' + file_id + '']);
}


refreshGrid(){ // refresh the databutton
 // this.getFiles();
 this.getSubjectNotesProgressionTable(this.job_id, this.file_number, this.model);
 
    console.log('' ,  this.gfunc.current_base_route)
    if(this.gfunc.current_base_route != '/client/jobs/create-job-wizard-step-3'){
    this.grid.refresh();
    }



};






// start of modal windows service as a template
openModal(template: TemplateRef<any>) {
  // small upgrade to disable background click on open modal background
  const config = { backdrop: true, ignoreBackdropClick: true, class: 'gray modal-lg' };
  this.modalRef = this.modalService.show(template, config);
}


// :: Parent / Child modal test
closeParentModel() {
  // alert('parent component function.');
  this.refreshGrid();
  this.modalRef.hide();
 
 // this.refreshGrid(); // resets the grid if updated and closed.
//  this.updateTypeClick = false; // closes the div

// :: Reloads the email list


};





clearSearchGrid() {
  this.grid.searchSettings.key = '';
}

searchGrid(name) {
  this.searchOptions = {  };
  this.grid.searchSettings.key = '';
  // const searchText: string = (document.getElementsByClassName('searchtext')[0] as any).value;
  const searchText: string = name;
  this.grid.search(searchText);

}

searchGridCol(name) {
// const searchText: string = (document.getElementsByClassName('searchtext')[0] as any).value;
// const searchText: string = name;
// this.grid.search(searchText);

// clear first
this.grid.searchSettings.key = '';
// now update the search uptions
this.searchOptions = { fields: ['note_type_name'], operator: 'contains', key: name, ignoreCase: true };
// now refresh the grid
this.grid.refresh();
}



// NOT WORKING
searchGridMasters(name) {
this.grid.searchSettings.key = '';
// now update the search uptions
this.searchOptions = { 
  fields: ['assigned_to_subjects'], operator: 'equal', key: name
 
};
// now refresh the grid
this.grid.refresh();

}


  // ::@https://stackblitz.com/edit/angular-bmxbmy?file=src%2Fapp%2Fapp.component.html
  getHtml(html){
    return this.sanitizer.bypassSecurityTrustHtml(html);

  }


// Copy copy to clipboard -- stackbix october 2023

copy(el) {
  if (el === 'btnOne') {
    this.btnOneTxt = COPIED;
  }
  if (el === 'btnTwo') {
    this.btnTwoTxt = COPIED;
  }

  setTimeout(() => {
    this.btnOneTxt = COPY;
    this.btnTwoTxt = COPY;
  }, 3000);
}

copyToClipboard() {
  const content = document.getElementById('note_content').innerHTML;
  this.clipboard.copy(content);
  this.copy('btnTwo');
}

copyToClipboardInGrid(id) {
  // const content = document.getElementById('note_content_' + id).innerHTML; // copy all formatting.
  const content = document.getElementById('note_content_' + id).innerText; // wet to copy text and formatting only
  // const content = document.getElementById('note_content_' + id).textContent; // removes all tags and formatting
  
  this.clipboard.copy(content);
  this,this.toastr.info("Note Copied")
  // this.copyInGrid('btnTwo', id);
}

copyToClipboardInGridHTML(id) {
  const content = document.getElementById('note_content_' + id).innerHTML; // copy all formatting.
  // const content = document.getElementById('note_content_' + id).innerText; // wet to copy text and formatting only
  this.clipboard.copy(content);
  this,this.toastr.info("Note Copied")
  // this.copyInGrid('btnTwo', id);
}

copyInGrid(el, id) {
  if (el === 'btnOne') {
    this.btnOneTxt = COPIED;
  }
  if (el === 'btnTwo') {
    this.btnTwoTxt = COPIED;
  }
}
// end clipboard functionss






getUsers() {
  this._demoService.getUsers().subscribe(
    data => { this.users = data;
      
     let res = data[0];

     this.usersList = data;

              // Ensure usersList is always an array of objects with correct types
              if (typeof this.usersList === 'string') {
                try {
                  this.usersList = JSON.parse(this.usersList);
                } catch (err) {
                  console.error('Failed to parse usersList JSON:', err);
                  this.usersList = [];
                }
              }

              if (!Array.isArray(this.usersList)) {
                // If it's wrapped in { data: [...] }
                if (this.usersList?.data && Array.isArray(this.usersList.data)) {
                  this.usersList = this.usersList.data;
                } else {
                  this.usersList = [];
                }
              }

              // Normalize number types
              this.usersList = this.usersList.map(u => ({
                ...u,
                // user_id: Number(u.user_id ?? u.id),
                // access_level: Number(u.access_level ?? u.user_level),
                // brand_type_id: Number(u.brand_type_id ?? u.brand_type) // just in case you need it
              }));



   },
    err => console.error(err),
    // () => console.log('done loading Trace Types')
  );
}







}
